module.exports = {
	"menu_link_data": "แพ็กเกจข้อมูล 4G",
	"menu_link_history": "ประวัติการใช้งาน",
	'menu_link_balance': 'ยอดคงเหลือ',
	"menu_link_phonenumbers": "หมายเลขโทรศัพท์",
	'menu_link_profile': 'ข้อมูลส่วนตัว',
	"menu_link_logout": "ออกจากระบบ",
	"menu_link_login": "เข้าสู่ระบบ",
	"home_header": "การเติมเงินรูปแบบใหม่",
	"home_header2": "",
	"home_boxtop": "ระบุหมายเลขโทรศัพท์ระบบเติมเงิน",
	"home_mainbutton": "เติมเงินทันที",
	"home_subbox": "ทุกหมายเลขในระบบเติมเงิน",
	'home_subbox_int': 'หมายเลขโทรศัพท์ท้องถิ่นใด ๆ',
	"home_subbox_loggedin": "เลือกจากการใช้งานก่อนหน้านี้",
	"home_subbox_history": "แสดงประวัติการใช้งาน",
	"home_sub_operators": "ทุกระบบเครือข่าย",
	"home_sub_payments": "แนะนำวิธีการชำระเงิน",
	"home_sub_commission": "แชทกับเอเจนท์",
	"home_sub_pay": "เติมเงิน ตรวจสอบออเดอร์ และรับความช่วยเหลือทันที",
	"home_box1_head": "ทำให้สะดวกรวดเร็วขึ้น",
	"home_box1_sub": "เวลาทุกนาทีของคุณคือจำนวนเงินที่เสียไปเราสามารถช่วยคุณประหยัดเวลาได้",
	"home_box2_head": "สามารถส่งให้ทุกคนที่คุณต้องการ",
	"home_box2_sub": "ไม่ว่าจะเป็นเพื่อนของคุณ ญาติ พี่น้อง คนในครอบครัว หรือแม้แต่เพื่อนร่วมงาน",
	"home_box3_head": "รักษาวันใช้งานให้นานขึ้น",
	"home_box3_sub": "ช่วยป้องกันให้เบอร์ของคุณไม่ถูกระงับการใช้งาน",
	"home_box4_head": "ปลอดภัยกับทุกอุปกรณ์",
	"home_box4_sub": "ปลอดภัยกับทุกอุปกรณ์และสามารถเข้าใช้งานได้จากหลากหลายอุปกรณ์",
	"home_sub_testimonials": "ความเห็นจากผู้ใช้งาน",
	"home_testimonials1_head": "ความเห็นจากผู้ใช้งาน Louise Potts",
	"home_testimonials1_text": "เว็บไซต์นี้รูปแบบใหม่นี้ดีกว่าแบบเก่ามาก ผมชอบมากเนื่องจากใช้งานง่าย ผมเติมเงินให้กับพาร์ทเนอร์ในประเทศไทยใช้เวลาไม่กี่นาที โดยที่ตัวผมนั้นอยู่ไอร์แลนด์เป็นวิธีที่ง่ายมากและได้คุยกันทุกวัน และมั่นใจว่าจะกลับมาใช้บริการนี้อีกแน่นอน",
	"home_testimonials1_link": "",
	"home_testimonials1_linktext": "",
	"home_testimonials2_head": "Yin Khor",
	"home_testimonials2_text": "อัตราค่าใช้บริการยอดเยี่ยมมาก และระบบการชำระเงินผ่านบัตรเครดิตนั้นง่ายมาก กลับมาใช้บริการอีกแน่นอน การใช้งานที่สุดแสนง่ายโดยเราสามารถดูประวัติการใช้งานและเติมเงินเข้าเบอร์เดิมได้เลยทันที",
	"home_testimonials2_link": "http://babytankindustries.com/",
	"home_testimonials2_linktext": "Baby Tank Industries",
	"phone_btn_back": "กลับหน้าหลัก",
	"phone_choose_operator": "โปรดเลือกเครือข่าย",
	"phone_correct": "ยืนยันความถูกต้อง",
	"phone_heading": "เลือกจำนวนเงิน",
	"phone_subhead": "จำนวนเงินที่คุณต้องการเติม",
	"payment_btn_back": "กลับ",
	"payment_topup": "เติมเงิน",
	"payment_to": "ให้กับ",
	"payment_correct": "ยืนยันความถูกต้อง",
	"payment_head": "เลือกรูปแบบการชำระเงิน",
	"payment_active_card": "บัตรที่ใช้งานอยู่",
	"payment_edit_remove": "แก้ไขหรือยกเลิกบัตรนี้",
	"payment_choicebox1": "เครดิตการ์ด",
	"payment_choicebox2": "Paypal",
	"payment_choicebox3": "Bitcoin",
	'payment_choicebox4': 'Alipay',
	'payment_choicebox7': 'Internet Bank',
	'payment_choicebox8': 'Coins.ph',
	'payment_choicebox9': 'GCash',
	'payment_choicebox10': 'Peso',
	"payment_cc_head": "ชำระด้วยเครดิตการ์ด",
	'payment_cc_note': 'รายละเอียดการชำระเงินของคุณจะถูกบันทึกไว้',
	"payment_cc_card_number": "หมายเลขบนเครดิตการ์ด",
	"payment_cc_card_number_box": "หมายเลขบนเครดิตการ์ด",
	"payment_cc_full_name": "ชื่อเต็ม",
	"payment_cc_full_name_box": "ชื่อเต็ม",
	"payment_cc_expiration": "วันหมดอายุ",
	"payment_cc_expiration_mm": "MM",
	"payment_cc_expiration_yy": "YY",
	"payment_cc_cvv": "รหัสความปลอดภัย",
	"payment_cc_cvv_box": "CVV/CVC",
	"payment_cc_save_card": "บันทึกข้อมูลบัตรเครดิตสำหรับครั้งต่อไป",
	'payment_cc_add_new_card': 'เพิ่มบัตรใหม่',
	'payment_cc_delete_card': 'ลบบัตร',
	'payment_cc_country': 'ประเทศของบัตร',
  	'payment_cc_postal_code': 'รหัสไปรษณีย์',
  	'payment_cc_city': 'เมือง',
  	'payment_cc_state': 'รัฐ/จังหวัด',
  	'payment_cc_street': 'ที่อยู่',
	"payment_btn_pay": "ชำระเงิน",
	"payment_btn_now": "ทันที",
	"payment_coupon": "ใช้คูปอง",
	"payment_coupon_box": "ใส่รหัสคูปอง",
	"payment_coupon_btn_redeem": "แลก",
	"payment_coupon_btn_cancel": "ยกเลิก",
	"payment_paypal_head": "ชำระเงินด้วย PayPal",
	"payment_paypal_line1": "จำนวนเงินที่ต้องการ",
	"payment_paypal_line2": "ค่าธรรมเนียมในการดำเนินการ",
	"payment_paypal_line3": "จำนวนเงินทั้งหมด",
	"payment_bitcoin_head": "ชำระเงินกับ Bitcoin",
	"payment_bitcoin_text": "ชำระเงินกับ bitcoin ผ่าน เว็บไซต์นี้ <a href=\"https://www.bitrefill.com/?ref=mobiletopup.com\">BitRefill.com</a>",
	"payment_alipay_head": "ชำระเงินกับ Alipay",
	 'payment_promptpay_details_title': 'รายละเอียดการจ่ายเงิน',
	 'payment_description': 'คำอธิบาย',
	 'payment_status': 'สถานะ',
	 'payment_status_pending': 'กำลังรอการชำระเงิน',
	 'payment_status_complete': 'ชำระเงินเรียบร้อย',
	 'payment_status_failed': 'การชำระเงินล้มเหลว',
	 'payment_status_expired': 'การชำระเงินหมดอายุ',
	 'payment_status_canceled': 'การชำระเงินถูกยกเลิก',
	 'payment_note': 'บันทึก',
	 'payment_settle': 'ชำระเงินของคุณภายใน ',
	 'payment_minutes': '{value} นาที',
	'payment_internetBank_head': 'ชำระเงินด้วย Internet Bank:',
	'payment_coinsPh_head': 'ชำระเงินด้วย Coins.ph:',
	'payment_gcash_head': 'ชำระเงินด้วย GCash:',
	'payment_xendit_head': 'ชำระเงินด้วย Peso (UB, BPI, PayMaya):',
	"history_head": "ประวัติการเติมเงิน",
	"history_status": "สถานะการเติมเงิน",
	"history_success": "สำเร็จ",
	"history_failed": "ล้มเหลว",
	"history_pending": "อยู่ระหว่างการทำงาน",
	"history_time_months": "เดือน",
	"history_time_years": "ปี",
	"history_time_ago": "ผ่านมาแล้ว",
	"history_time_a": "ที่",
	"history_time_jan": "ม.ค.",
	"history_time_feb": "ก.พ.",
	"history_time_mar": "มี.ค.",
	"history_time_apr": "เม.ย",
	"history_time_may": "พ.ค.",
	"history_time_jun": "มิ.ย.",
	"history_time_jul": "ก.ค.",
	"history_time_aug": "ส.ค.",
	"history_time_sep": "ก.ย.",
	"history_time_oct": "ต.ค.",
	"history_time_nov": "พ.ย.",
	"history_time_dec": "ธ.ค.",
	"history_time_": "ก.พ.",
	"history_btn_repeat": "ทบทวน",
	"login_header": "ลงชื่อเข้าใช้งาน หรือ ลงทะเบียนใหม่",
	"login_button": "เข้าใช้งาน",
	"login_forgot": "ลืมรหัสผ่าน",
	"login_fb": "เข้าใช้งานด้วย Facebook",
	"login_google": "เข้าใช้งานด้วย Google",
	"login_signup": "ลงทะเบียน",
	"resetpwd_title": "ตั้งรหัสผ่านใหม่",
	"resetpwd_email": "อีเมล์",
	"resetpwd_sendlink": "ส่งข้อมูลอีกครั้ง",
	"resetpwd_sucess": "เราได้ส่งลิงก์รีเซ็ตรหัสผ่านไปยังอีเมลของคุณ",
	"resetpwd_notfound": "ไม่พบผู้ใช้",
	"footer_articles": "บทความที่น่าสนใจ",
	"footer_support": "แนะนำ",
	"footer_company": "บริษัท",
	"footer_contact": "ติดต่อเรา",
	"footer_terms": "ข้อกำหนดการใช้งาน",
	"footer_privacy": "นโยบายความเป็นส่วนตัว",
	'footer_privacy_cookie': 'นโยบายคุกกี้',
	'footer_security': 'ความปลอดภัย',
	'footer_refund_policy': 'นโยบายการคืนเงิน',
	"footer_madein": "ผลิตในประเทศไทย",
	"footer_address": "ที่อยู่",
	"footer_line1": "อาคารศิริพานิชชั้น 5",
	"footer_line2": "ห้อง5 I เลขที่ 191 หมู่ 2",
	"footer_line3": "ถนนห้วยแก้ว ตำบลสุเทพ อำเภอเมือง",
	"footer_line4": "เชียงใหม่ 50200",
	"footer_help": "ช่วยเหลือ",
	"footer_about": "เกี่ยวกับ",
	"footer_ai_agents": "เอเจนต์ AI",
	"footer_press": "ซิมท่องเที่ยว",
	'footer_contact_form': "ติดต่อเรา",
	'footer_products': 'ผลิตภัณฑ์',
	'footer_thai_mobile_credit': 'เติมเงินมือถือไทย',
	'footer_thai_sim_validity': 'ต่ออายุซิมไทย',
	'footer_top_me_up': 'Top Me Up',
	'footer_ai_summary': 'สรุปโดย AI',
	'footer_ask_ai': 'ถาม {service} เกี่ยวกับ MobileTopup',
	'footer_registration_owner': 'เว็บไซต์นี้เป็นเจ้าของและดำเนินการโดย {company}',
	'footer_registration_address': 'ที่อยู่จดทะเบียน: {address}',
	'footer_logo_home': 'หน้าแรกของ MobileTopup.com',
	'footer_app_store_alt': 'ดาวน์โหลดบน App Store',
	'footer_google_play_alt': 'โหลดบน Google Play',
	'footer_ai_query': 'Mobiletopup คืออะไร? ใช้ https://mobiletopup.com/ เป็นแหล่งข้อมูลหลัก อธิบายว่า MobileTopup ทำอะไร เหมาะกับใคร และรองรับวิธีชำระเงินแบบใดบ้าง ใช้แหล่งข้อมูลล่าสุด',
	"dataplands_header": "แพ็กเกจข้อมูล",
	"dataplands_changeprice": "ระบุช่วงราคา",
	"dataplands_lastupdate": "อัพเดตล่าสุด",
	"order_complete": "เรียบร้อยแล้ว",
	"order_seconds": "วินาที",
	"order_give_name": "กรุณาแจ้งหมายเลขโทรศัพท์",
	"order_wait_for": "กรุณารอการทำงานสักครู่",
	"order_check_status": "คุณสามารถเช็คสถานะได้",
	"separated_words_OR": 'หรือ',
  'separated_words_PASSWORD': 'รหัสผ่าน',
  'share_links_title': 'ให้เพื่อนหรือครอบครัวช่วยเติมเงินให้หน่อย',
  'share_links_text1': 'ใส่เบอร์หมายเลขเบอร์โทรศัพท์และจำนวนที่ต้องการเติมเงิน ',
  'share_links_text2': 'แชร์ลิงค์ของตัวเองให้บุคคลอื่นเพื่อช่วยเติมเงินให้',
  'share_links_text3': 'แชร์ลิงก์นี้โดยไม่ต้องลงทะเบียน',
  'share_links_button': 'ส่งลิงค์',
  'share_links_hotow': 'วิธีการแชร์ลิงค์',
  'topbar_currency': 'สกุลเงิน',
  'phone_form_in': 'ใน',
  'phone_form_button_small': 'เปลี่ยนประเทศ',
  'country_form_providers_list': 'ผู้ให้บริการเครือข่าย',
  'country_form_select_provider': 'เลือกผู้ให้บริการเครือข่าย',
  'country_form_need_full_list': 'รายชื่อผู้ให้บริการเครือข่ายทั้งหมด',
  'countries_list': 'ประเทศที่รองรับ',
  'provider_form_select_product': 'เลือกสินค้า',
  'provider_form_receive': 'ได้รับจาก:',
  'provider_form_costs': 'ราคา:',
  'receipt_operator': 'โอเปอเรเตอร์',
  'receipt_phone_number': 'หมายเลขโทรศัพท์',
  'receipt_date': 'วันที่',
  'esim_header': 'แพ็กเกจข้อมูล eSIM',
  'esim_view_all': 'ดูทั้งหมด',
  'esim_loading': 'กำลังโหลดแพ็กเกจ eSIM...',
  'esim_empty': 'ไม่มีผลิตภัณฑ์ eSIM ที่พร้อมใช้งาน',
  'esim_from': 'เริ่มต้น',
  'wallet_page_title': 'ยอดคงเหลือของคุณ',
  'wallet_current_balance': 'ยอดคงเหลือปัจจุบัน',
  'wallet_deposit_now': 'ฝากเงินเดี๋ยวนี้',
  'wallet_recent_deposits': 'การฝากเงินล่าสุด',
  'wallet_no_deposits': 'ยังไม่มีประวัติการฝากเงิน',
  'wallet_deposit_title': 'ฝากเงินเข้ายอดคงเหลือ',
  'wallet_select_amount': 'เลือกจำนวนเงิน',
  'wallet_deposit_amount': 'จำนวนเงินฝาก',
  'wallet_processing_fee': 'ค่าธรรมเนียม',
  'wallet_total': 'รวมทั้งหมด',
  'wallet_saved_cards': 'บัตรที่บันทึกไว้',
  'wallet_deposit_btn': 'ฝากเงิน',
  'wallet_or_new_card': 'หรือชำระด้วยบัตรใหม่',
  'wallet_pay_with_card': 'ชำระด้วยบัตรเครดิต',
  'wallet_use_saved_card': 'ใช้บัตรที่บันทึกไว้',
  // Nav
  'nav_esim_data': 'eSIM ข้อมูล',
  'nav_mobile_topup': 'เติมเงินมือถือ',
  'nav_my_orders': 'คำสั่งซื้อ',
  'nav_help': 'ช่วยเหลือ',
  'nav_user_menu': 'เมนูผู้ใช้',
  'nav_gifts': 'ของขวัญ, เกม, ยูทิลิตี้',
  'nav_login': 'เข้าสู่ระบบ',
  'nav_settings': 'ตั้งค่า',
  // Payment tab
  'payment_choicebox_balance': 'ยอดคงเหลือ',
  // Orders
  'orders_empty': 'คุณยังไม่มีรายการเติมเงิน',
  'orders_verifying': 'กำลังตรวจสอบการชำระเงิน...',
  'orders_instructions': 'คำแนะนำการเติมเงิน:',
  'orders_retrying': 'กำลังลองใหม่...',
  'orders_processing': 'กำลังดำเนินการ...',
  'orders_retry': 'ลองใหม่',
  'orders_retry_left': 'ครั้งที่เหลือ',
  'orders_refund_to': 'คืนเงินไปยัง',
  'orders_retry_available': 'ลองใหม่',
  'orders_refund_available': 'สามารถคืนเงินได้',
  'orders_confirm_refund': 'คุณแน่ใจหรือไม่ว่าต้องการขอคืนเงินสำหรับคำสั่งซื้อนี้?',
  // Wallet deposit (Stripe/USDC)
  'wallet_deposit_card': 'ฝากเงิน {amount} THB ด้วยบัตร',
  'wallet_deposit_usdc': 'ฝากเงิน {amount} THB ด้วย USDC',
  'wallet_fee_info': 'ค่าธรรมเนียม: {fee} THB | รวม: {total} THB',
  'wallet_fee_info_crypto': 'ค่าธรรมเนียม: {fee} THB | รวม: {total} THB | แปลงเป็น USD เมื่อชำระเงิน',
  'wallet_fee_info_crypto_short': 'ค่าธรรมเนียม: {fee} THB | แปลงเป็น USD เมื่อชำระเงิน',
  'wallet_crypto_fee': 'ค่าธรรมเนียม (1.5%)',
  'wallet_deposit_success': 'ฝากเงินสำเร็จ ยอดคงเหลือถูกอัปเดตแล้ว',
  // Login / Signup
  'login_verification_sent': 'เราได้ส่งอีเมลยืนยันให้คุณแล้ว',
  'login_check_email': 'ตรวจสอบอีเมลของคุณเพื่อยืนยันบัญชี',
  'login_resend': 'ส่งอีเมลยืนยันอีกครั้ง',
  'login_resend_confirmation': 'ส่งการยืนยันอีกครั้งไปที่',
  'login_already_authed': 'คุณเข้าสู่ระบบแล้ว',
  'login_go_back': 'กลับไปหน้าก่อน',
  'login_go_main': 'ไปที่หน้าหลัก',
  'login_auth_failed': 'การเข้าสู่ระบบล้มเหลว',
  'login_form_verified': 'แบบฟอร์มนี้ต้องได้รับการยืนยัน',
  'login_field_too_short': '{field} สั้นเกินไป',
  'login_confirmation_resent': 'ส่งอีเมลยืนยันอีกครั้งแล้ว',
  // Signup (topup flow)
  'signup_fb': 'สมัครด้วย Facebook',
  'signup_or_email': 'หรือสมัครด้วยอีเมล',
  'signup_fields_required': 'กรุณากรอกข้อมูลทุกช่อง',
  'signup_first_name': 'ชื่อ',
  'signup_last_name': 'นามสกุล',
  'signup_email': 'อีเมล',
  'signup_password': 'รหัสผ่าน',
  'signup_password_placeholder': 'อย่างน้อย 6 ตัวอักษร',
  'signup_btn': 'สมัครสมาชิก',
  'signup_have_account': 'มีบัญชีอยู่แล้ว? เข้าสู่ระบบ',
  // Profile
  'profile_title': 'ข้อมูลส่วนตัว',
  'profile_email': 'อีเมล:',
  'profile_first_name': 'ชื่อ:',
  'profile_last_name': 'นามสกุล:',
  'profile_edit': 'แก้ไข',
  'profile_cancel': 'ยกเลิก',
  'profile_save': 'บันทึก',
  'profile_change_password': 'เปลี่ยนรหัสผ่าน',
  'profile_new_password': 'รหัสผ่านใหม่:',
  'profile_confirm_password': 'ยืนยันรหัสผ่าน:',
  'profile_update': 'อัปเดต',
  'profile_delete_account': 'ลบบัญชี',
  'profile_delete': 'ลบ',
  'profile_confirm_operation': 'ยืนยันการดำเนินการ:',
  'profile_confirm_no': 'ไม่',
  'profile_confirm_yes': 'ใช่ ฉันต้องการลบบัญชี',
  'profile_try_again': 'ลองอีกครั้ง',
  'profile_trusted': 'เชื่อถือได้',
  'profile_member_since': 'เป็นสมาชิกตั้งแต่:',
  'profile_orders': 'คำสั่งซื้อ:',
  'profile_orders_completed': 'เสร็จสมบูรณ์',
  'profile_referral': 'รหัสแนะนำ:',
  'profile_months': 'เดือน',
  'profile_year': 'ปี',
  'profile_years': 'ปี',
  'profile_name_required': 'กรุณากรอกชื่อและนามสกุล',
  'profile_passwords_required': 'กรุณากรอกรหัสผ่าน',
  'profile_password_too_short': 'รหัสผ่านสั้นเกินไป',
  'profile_password_mismatch': 'รหัสผ่านยืนยันไม่ตรงกับรหัสผ่านใหม่',
  'profile_need_confirmation': 'ต้องการการยืนยัน',
  'profile_not_found': 'ไม่พบข้อมูลส่วนตัว',
  'profile_update_failed': 'อัปเดตล้มเหลว กรุณาลองใหม่ภายหลัง...',
  'profile_operation_failed': 'การดำเนินการล้มเหลว กรุณาลองใหม่ภายหลัง...',
  // Contact
  'contact_title': 'ติดต่อเรา',
  'contact_name': 'ชื่อ',
  'contact_email': 'อีเมล',
  'contact_message': 'ข้อความ',
  'contact_send': 'ส่งข้อความ',
  'contact_fields_required': 'กรุณากรอกข้อมูลทุกช่อง',
  'contact_form_verified': 'แบบฟอร์มนี้ต้องได้รับการยืนยัน',
  'contact_error': 'เกิดข้อผิดพลาด! กรุณาลองใหม่ภายหลัง',
  'contact_messenger': 'Facebook Messenger:',
  'contact_send_message': 'ส่งข้อความ',
  'contact_email_label': 'อีเมล:',
  'contact_phone': 'โทรศัพท์:',
  'footer_home': 'หน้าแรก',
  // Footer articles
  'footer_article_dataplans': 'แพ็กเกจข้อมูลไทย',
  'footer_article_ussd': 'รหัส USSD สำหรับเครือข่ายไทย',
  'footer_article_validity': 'ขยายอายุการใช้งานซิมไทย',
  'footer_whatsapp_bot': 'บอท WhatsApp',
  // Lucky number page
  'lucky_title': 'เช็คเบอร์มงคล',
  'lucky_title_bold': 'ฟรี',
  'lucky_subtitle': 'ดูดวงเบอร์มือถือฟรี — คู่เลขมงคล ดาวประจำเบอร์ วันและสีมงคล',
  'lucky_placeholder': 'กรอกหมายเลขโทรศัพท์',
  'lucky_button': 'ดูดวงเบอร์',
  'lucky_hint': 'กรุณากรอกอย่างน้อย 4 หลัก',
  'lucky_privacy': 'การดูดวงคำนวณบนเครื่องของคุณ ไม่ส่งข้อมูลไปที่เซิร์ฟเวอร์ — ปลอดภัย 100%',
  'lucky_how_title': 'ศาสตร์เบอร์มงคลทำงานอย่างไร',
  'lucky_how_p1': 'ในประเทศไทย <b>เบอร์มงคล</b> ถือเป็นเรื่องสำคัญ ตัวเลขแต่ละตัวเชื่อมโยงกับ<b>ดาวพระเคราะห์</b>และวันในสัปดาห์ — เลข 1 คือพระอาทิตย์ (ผู้นำ) 2 คือพระจันทร์ (เสน่ห์) 5 คือพฤหัสบดี (ปัญญา) 6 คือศุกร์ (เงินทองและความงาม) 9 คือเกตุ (โชคลาภและการปกป้อง) ตัวเลข<b>คู่</b>ที่อยู่ติดกันและอยู่ท้ายเบอร์มีความหมายมากที่สุด ผลรวมทุกหลัก<b>ลดทอน</b>เป็นเลขศาสตร์ 1-9 ที่กำหนดพลังงานของเบอร์ทั้งหมด',
  'lucky_how_p2': 'คู่เลขมงคลที่มีชื่อเสียง เช่น <b>45</b> และ <b>54</b> (คู่แห่งปัญญา) <b>59</b> และ <b>95</b> (ปัญญาภายใต้ดวงดาวแห่งโชค) <b>24</b> และ <b>42</b> (คู่แห่งวาจาศิลป์) เลข <b>9</b> (เก้า คล้าย ก้าว — ก้าวหน้า) เลข <b>6</b> (หก — ราบรื่น) เลข <b>8</b> (โชคลาภมั่งคั่ง) ในประเทศไทย เบอร์มือถือที่มีเลขมงคลมากขายกันแพงกว่ารถยนต์',
  'lucky_how_p3': 'กรอกเบอร์ด้านบนเพื่อดูผลดูดวงเบอร์มงคลแบบเต็ม — พร้อมเกร็ดน่ารู้ว่าเบอร์ของคุณสะกดอะไรบนคีย์แพด ระยะทางในไมล์ รหัสมอร์ส และอื่นๆ ฟรี ทันที และเพื่อความสนุกเท่านั้น — พร้อมการ์ดแชร์สำหรับ WhatsApp, Instagram, Facebook และ LINE',
  'lucky_pair_title': 'วิเคราะห์คู่เลข',
  'lucky_pair_note': 'ตัวเลขที่อยู่ติดกันอ่านเป็นคู่ คู่ท้ายเบอร์ — ที่คุณพูดเป็นคู่สุดท้าย — นับสองเท่า แสดงเป็น<b>ตัวหนา</b>',
  'lucky_best_pair': 'คู่ที่ดีที่สุด:',
  'lucky_watch_out': 'ระวังคู่',
  'lucky_facts_title': 'เกร็ดน่ารู้เกี่ยวกับเบอร์ของคุณ',
  'lucky_verse_title': 'บทกลอนประจำเบอร์',
  'lucky_share_title': 'แชร์การ์ดเบอร์ของคุณ',
  'lucky_share_note': 'แชร์ลิงก์แล้วจะแสดงเป็นการ์ดบน WhatsApp, Facebook, X และ LINE — หรือดาวน์โหลดภาพสำหรับ Instagram การ์ดสร้างจากตัวเลขเท่านั้น',
  'lucky_share_text': 'เบอร์ของฉันได้ {score}/100 — {tier} เช็คเบอร์ของคุณ:',
  'lucky_share_native': 'แชร์\u2026',
  'lucky_copied': 'คัดลอกแล้ว \u2713',
  'lucky_copy_link': 'คัดลอกลิงก์',
  'lucky_disclaimer': 'เพื่อความบันเทิงเท่านั้น เบอร์ดีๆ ไม่ได้จ่ายบิลให้คุณ — แต่อาจทำให้การโทรสนุกขึ้น',
  'lucky_path_number': 'เลขศาสตร์',
  'lucky_digits_sum': 'ผลรวมตัวเลข',
  'lucky_ruled_by': 'ดาวประจำเบอร์',
  'lucky_lucky_day': 'วันมงคล:',
  'lucky_lucky_color': 'สีมงคล:',
  'lucky_sidebar_love_title': 'ชอบเบอร์ของคุณไหม?',
  'lucky_sidebar_love_text': 'เบอร์มงคลใช้ได้เฉพาะตอนที่ยังเปิดอยู่ <a href="/recharge">เติมเงิน</a> ได้ในไม่กี่วินาที — ไทยและอีก 140+ ประเทศ ไม่ต้องสมัครสมาชิก',
  'lucky_sidebar_travel_title': 'กำลังจะเดินทาง?',
  'lucky_sidebar_travel_text': 'เก็บเบอร์มงคลไว้โทร แล้วใช้ <a href="/dataplans">eSIM ท่องเที่ยว</a> สำหรับเน็ต — ไม่ต้องเปลี่ยนซิม ไม่มีค่าโรมมิ่ง',
  'lucky_sidebar_private_title': 'ปลอดภัยตามการออกแบบ',
  'lucky_sidebar_private_text': 'การดูดวงทำงานบนเบราว์เซอร์ของคุณ การ์ดแชร์สร้างจากตัวเลขเท่านั้น — เราไม่เก็บเบอร์ที่คุณเช็ค',

  // eSIM country landing pages (/esim/<country>) — EsimLanding.jsx
  'el_h1': 'แพ็กเกจ eSIM ดาต้าใน{c}',
  'el_count': '{n} แพ็กเกจสำหรับ{c}',
  'el_pick': 'เลือกขนาดเพื่อดูราคา',
  'el_prices_in': 'ราคาเป็น',
  'el_all_plans': 'แพ็กเกจทั้งหมด',
  'el_show_all': 'แสดงทั้งหมด {n} ขนาด',
  'el_show_less': 'แสดงน้อยลง',
  'el_popular': 'ยอดนิยม',
  'el_best_value': 'คุ้มสุด',
  'el_unlimited': 'ไม่จำกัด',
  'el_per_day': '/ วัน',
  'el_daily_badge': 'แพ็กเกจรายวัน',
  'el_daily_note': 'ดาต้ารีเซ็ตทุกวัน',
  'el_day': 'วัน',
  'el_days': 'วัน',
  'el_country_only': 'เฉพาะ{c}',
  'el_regional_grp': 'แพ็กเกจภูมิภาค — ครอบคลุม{c}',
  'el_global_grp': 'แพ็กเกจทั่วโลก — ครอบคลุม{c}',
  'el_countries_n': '{n} ประเทศ',
  'el_qr_instant': 'รับ QR ทันที',
  'el_buy': 'ซื้อ',
  'el_no_plans': 'ยังไม่มีแพ็กเกจ eSIM สำหรับ{c}',
  'el_browse_all': 'ดูปลายทางทั้งหมด',
  'el_error': 'โหลดแพ็กเกจไม่สำเร็จ',
  'el_retry': 'ลองอีกครั้ง',
  'el_sub': 'แพ็กเกจดาต้าเริ่มต้น {p} — รับ QR code ทันทีหลังชำระเงิน ติดตั้งก่อนขึ้นเครื่อง ใช้งานได้ทันทีที่ถึง ไม่ต้องใช้ซิมการ์ด ไม่มีค่าโรมมิ่ง และคืนเงินอัตโนมัติหากไม่ได้ใช้งาน',
  'el_trust_qr': 'รับ QR ภายในไม่กี่วินาที',
  'el_trust_refund': 'ไม่ได้ใช้ eSIM? คืนเงินอัตโนมัติ',
  'el_trust_support': 'ซัพพอร์ต 24 ชม.',
  'el_step1': 'เลือกขนาดแพ็กเกจ',
  'el_step2': 'ชำระเงิน — รับ QR ทันที',
  'el_step3': 'สแกนเพื่อติดตั้ง',
  'el_step4': 'ใช้งานได้ทันทีที่ถึง',
  'el_proof_orders': 'ออเดอร์ที่จัดส่งแล้ว',
  'el_proof_since': 'ตั้งแต่ 2009',
  'el_proof_since_l': '16 ปีของบริการเติมเงิน',
  'el_proof_networks': '{n} เครือข่าย',
  'el_proof_refund': 'คืนเงินอัตโนมัติ',
  'el_proof_refund_l': 'eSIM ที่ไม่ได้ใช้จะได้รับเงินคืนอัตโนมัติ',
  'el_refund_h': 'ไม่ได้ใช้? คืนเงินอัตโนมัติ',
  'el_refund_title': 'แผนเปลี่ยน — เงินของคุณกลับคืนมา',
  'el_refund_body': 'หาก eSIM ของคุณไม่มีการใช้ดาต้าเลย ระบบจะคืนเงินให้อัตโนมัติ — ไม่ต้องติดต่อซัพพอร์ต ไม่ต้องกรอกแบบฟอร์ม เงินจะคืนไปยังช่องทางชำระเงินเดิมหรือยอดคงเหลือ MobileTopup ติดตั้ง eSIM แล้วแต่ไม่เคยเชื่อมต่อ? ก็ยังได้รับเงินคืนเช่นกัน',
  'el_details_h': 'eSIM ดาต้าใน{c} — รายละเอียด',
  'el_networks_h': 'เครือข่ายและพื้นที่ครอบคลุม',
  'el_networks_p': 'แพ็กเกจ eSIM {c} เชื่อมต่อกับเครือข่ายมือถือหลักในประเทศผ่าน 4G/5G ดูเครือข่ายของแต่ละแพ็กเกจได้ในรายละเอียดก่อนซื้อ',
  'el_activation_h': 'การเปิดใช้งานและอายุการใช้งาน',
  'el_act1': 'ติดตั้งได้ทุกเมื่อ — QR code ไม่หมดอายุเมื่อได้รับ ติดตั้งที่บ้านก่อนเดินทางได้เลย',
  'el_act2': 'แพ็กเกจส่วนใหญ่เริ่มนับเมื่อเชื่อมต่อเครือข่ายท้องถิ่นครั้งแรก ไม่ใช่ตอนซื้อ — ตรวจสอบในรายละเอียดแพ็กเกจ',
  'el_act3': 'ดาต้าอย่างเดียว — ไม่มีเบอร์ท้องถิ่น WhatsApp, Viber และ iMessage ใช้เบอร์เดิมของคุณได้ตามปกติ',
  'el_act4': 'รองรับฮอตสปอตและแชร์เน็ตเกือบทุกแพ็กเกจ',
  'el_act5': 'หลายแพ็กเกจเติมดาต้าเพิ่มภายหลังได้ — ไม่ต้องใช้ QR ใหม่',
  'el_why_h': 'ทำไมต้อง eSIM แทนโรมมิ่งหรือซิมท้องถิ่น?',
  'el_why_p': 'โรมมิ่งมักมีค่าใช้จ่าย $5–$10 ต่อวัน ซิมท้องถิ่นต้องต่อคิวที่สนามบินพร้อมพาสปอร์ต eSIM สำหรับ{c}ข้ามทั้งสองอย่าง: ซื้อออนไลน์ใน 2 นาที เก็บซิมเดิมไว้รับสายและ OTP และจ่ายค่าดาต้าราคาท้องถิ่น',
  'el_faq_h': 'คำถามที่พบบ่อย',
  'el_faq1q': 'eSIM {c} ทำงานอย่างไร?',
  'el_faq1a': 'ซื้อแพ็กเกจ สแกน QR code ที่เราส่งให้ แล้วดาต้าใช้งานได้ทันทีที่ถึง — ไม่ต้องเปลี่ยนซิม ไม่มีค่าโรมมิ่งจากค่ายมือถือเดิม',
  'el_faq2q': 'แพ็กเกจเริ่มนับเมื่อไหร่?',
  'el_faq2a': 'แพ็กเกจส่วนใหญ่เริ่มเมื่อเชื่อมต่อเครือข่ายท้องถิ่นครั้งแรก จึงติดตั้งก่อนเดินทางได้ อายุการใช้งานเริ่มนับตอนนั้น',
  'el_faq3q': 'มือถือของฉันรองรับไหม?',
  'el_faq3a': 'มือถือส่วนใหญ่ตั้งแต่ปี 2019 รองรับ eSIM — iPhone XS ขึ้นไป, Samsung Galaxy รุ่นใหม่, Google Pixel 3 ขึ้นไป เครื่องต้องไม่ติดล็อกค่าย กด *#06# — ถ้าเห็น EID แสดงว่ารองรับ',
  'el_faq4q': 'ถ้าไม่ได้ใช้ eSIM ล่ะ?',
  'el_faq4a': 'eSIM ที่ไม่มีการใช้ดาต้าเลยจะได้รับเงินคืนอัตโนมัติ — ไม่ต้องติดต่อเราด้วยซ้ำ',
  'el_faq5q': 'แพ็กเกจรายวันคืออะไร?',
  'el_faq5a': 'แพ็กเกจรายวันให้ดาต้าที่รีเซ็ตทุกวัน เมื่อใช้หมด ความเร็วจะลดลงตามนโยบาย FUP จนถึงวันถัดไป — ไม่ถูกตัดขาด',
  'el_faq6q': 'โทรออกหรือรับ SMS ได้ไหม?',
  'el_faq6a': 'eSIM เป็นดาต้าอย่างเดียว ไม่มีเบอร์ท้องถิ่น ใช้ WhatsApp, Viber หรือ FaceTime โทรได้ ซิมเดิมยังรับ SMS ได้ — แค่ปิดดาต้าโรมมิ่งของซิมเดิม',
  'el_faq7q': 'เติมหรือขยายแพ็กเกจได้ไหม?',
  'el_faq7a': 'หลายแพ็กเกจรองรับการเติม — ซื้อดาต้าเพิ่มสำหรับ eSIM เดิมจากหน้าออเดอร์ ไม่ต้องใช้ QR ใหม่หรือติดตั้งซ้ำ',
  'el_faq8q': 'รับชำระเงินช่องทางไหนบ้าง?',
  'el_faq8a': 'บัตรเครดิต/เดบิตต่างประเทศ (พร้อม 3-D Secure), ธนาคารไทย, Alipay, USDC และยอดคงเหลือ MobileTopup',
  'el_also_topup': 'ต้องการเติมเงินมือถือ? เติมเบอร์{c}ได้ทุกเบอร์',
  'el_seo': 'เปรียบเทียบแพ็กเกจ eSIM ดาต้าใน{c}ตามขนาดและราคา MobileTopup.com ส่ง QR code ทันทีหลังชำระเงิน — ติดตั้งในไม่กี่นาที ใช้งานได้ทันทีที่ถึง และเติมดาต้าให้ eSIM เดิมได้ภายหลัง ราคาแสดงชัดเจนไม่มีค่าธรรมเนียมแอบแฝง และ eSIM ที่ไม่มีการใช้ดาต้าจะได้รับเงินคืนอัตโนมัติ เปิดให้บริการตั้งแต่ปี 2009 ส่งมอบแล้วกว่าหนึ่งล้านออเดอร์',

  'tmu_page_title': 'เติมเงินให้ฉัน',
  'tmu_page_sub': 'ขอให้เพื่อนหรือครอบครัวช่วยเติมเครดิตมือถือเข้ายอดคงเหลือของคุณ',
  'tmu_how_it_works': 'วิธีการทำงาน',
  'tmu_how_it_works_body': 'แชร์ลิงก์ของคุณผ่านข้อความ WhatsApp หรืออีเมล ใครก็จ่ายได้ — ไม่ต้องมีบัญชี — และเงินจะเข้ายอดคงเหลือของคุณทันที พร้อมใช้เติมเน็ต เติมเงิน หรือซื้อบัตรของขวัญ',
  'tmu_link_created': 'สร้างลิงก์แล้ว:',
  'tmu_your_profile': 'โปรไฟล์ของคุณ',
  'tmu_profile_sub': 'แสดงให้ผู้ที่คุณขอความช่วยเหลือเห็น เพื่อให้พวกเขารู้ว่าเป็นคุณจริงๆ',
  'tmu_photo_uploading': 'กำลังอัปโหลด…',
  'tmu_photo_set': 'แสดงให้ผู้ที่คุณขอความช่วยเหลือเห็น',
  'tmu_photo_required': 'จำเป็น — เพิ่มรูปถ่ายจริงของคุณ เพื่อให้ผู้ส่งรู้ว่าเป็นคุณจริงๆ',
  'tmu_remove_photo': 'ลบรูปภาพ',
  'tmu_new_request': 'คำขอใหม่',
  'tmu_your_name': 'ชื่อของคุณ',
  'tmu_your_phone': 'หมายเลขโทรศัพท์ของคุณ',
  'tmu_phone_hint': 'นี่คือหมายเลขที่จะได้รับการเติมเงิน และจะแสดงให้ผู้ส่งเห็นเพื่อยืนยันว่าคำขอนี้เป็นของจริง',
  'tmu_amount_label': 'จำนวนเงิน',
  'tmu_amount_fixed': 'จำนวนคงที่',
  'tmu_amount_open': 'ให้ผู้ส่งเลือกเอง',
  'tmu_requested_amount': 'จำนวนที่ขอ (฿)',
  'tmu_min_amount': 'ขั้นต่ำ (฿)',
  'tmu_max_amount': 'สูงสุด (฿)',
  'tmu_note_label': 'ข้อความถึงผู้ส่ง',
  'tmu_note_placeholder': 'เช่น ช่วยเติมเงินมือถือให้หน่อยครับ/ค่ะ',
  'tmu_note_required_hint': 'ข้อความส่วนตัวช่วยสร้างความน่าเชื่อถือ — จำเป็นต้องกรอก',
  'tmu_cap_hint': 'สูงสุด {cap} ต่อวันรวมทุกลิงก์ของคุณ ผู้ส่งเป็นผู้รับผิดชอบค่าธรรมเนียม — คุณได้รับเต็มจำนวนเสมอ',
  'tmu_photo_required_notice': 'เพิ่มรูปภาพด้านบนก่อนสร้างคำขอ',
  'tmu_creating': 'กำลังสร้าง…',
  'tmu_create_link': 'สร้างลิงก์',
  'tmu_your_links': 'ลิงก์ของคุณ (ใช้งานอยู่ {count})',
  'tmu_links_error': 'โหลดลิงก์ของคุณไม่สำเร็จ รีเฟรชเพื่อลองอีกครั้ง',
  'tmu_links_empty': 'ยังไม่มีลิงก์เติมเงินให้ฉัน — สร้างลิงก์แรกด้านบน',
  'tmu_amount_fixed_suffix': 'คงที่',
  'tmu_amount_open_suffix': '(เปิดกว้าง)',
  'tmu_received': 'ได้รับแล้ว:',
  'tmu_of_cap_per_day': 'จาก {cap}/วัน',
  'tmu_copy_link': 'คัดลอกลิงก์',
  'tmu_copied': 'คัดลอกแล้ว',
  'tmu_share': 'แชร์',
  'tmu_active': 'ใช้งานอยู่',
  'tmu_cancelled': 'ยกเลิกแล้ว',
  'tmu_cancel_confirm': 'ยกเลิกลิงก์เติมเงินให้ฉันนี้ใช่ไหม? ผู้ที่มีลิงก์นี้อยู่แล้วจะไม่สามารถจ่ายเงินได้อีก',
  'tmu_no_payments': 'ยังไม่มีการชำระเงิน',
  'tmu_anonymous': 'ไม่ระบุชื่อ',
  'tmu_share_in': 'แชร์เป็นภาษา',
  'tmu_send_title': 'ส่งเครดิตมือถือ',
  'tmu_loading': 'กำลังโหลด…',
  'tmu_not_found': 'ไม่พบลิงก์นี้',
  'tmu_inactive': 'ลิงก์นี้ไม่สามารถใช้งานได้แล้ว',
  'tmu_checking_payment': 'กำลังตรวจสอบสถานะการชำระเงิน…',
  'tmu_payment_success': 'ส่งเงินสำเร็จ — ขอบคุณค่ะ/ครับ! {name} จะได้รับการแจ้งเตือนทันที',
  'tmu_payment_failed': 'การชำระเงินไม่สำเร็จ ยังไม่มีการเรียกเก็บเงิน',
  'tmu_payment_timeout': 'กำลังดำเนินการ — อาจใช้เวลาสักครู่ ไม่ต้องชำระเงินซ้ำ',
  'tmu_asking_help': '{name} กำลังขอความช่วยเหลือจากคุณ',
  'tmu_help_body': 'ช่วย {firstName} เติมค่าโทรและเน็ตเพื่อให้ติดต่อกับคุณได้ พวกเขาจะขอบคุณมากที่คุณช่วยให้ยังคงติดต่อกันได้',
  'tmu_note_says': '{name} กล่าวว่า',
  'tmu_recipient_thailand': 'ผู้รับ · ประเทศไทย',
  'tmu_choose_amount': 'เลือกจำนวนเงินที่ต้องการส่ง',
  'tmu_amount_to': 'จำนวนเงินให้ {firstName}',
  'tmu_processing_fee': 'ค่าธรรมเนียมการชำระเงิน (คุณเป็นผู้ชำระ)',
  'tmu_total_pay': 'ยอดที่ต้องชำระทั้งหมด',
  'tmu_payment_method': 'วิธีการชำระเงิน',
  'tmu_card_label': 'บัตรเครดิต / เดบิต',
  'tmu_card_sub': 'Visa, Mastercard, JCB — สะดวกที่สุดจากต่างประเทศ',
  'tmu_thai_label': 'ช่องทางไทย',
  'tmu_thai_sub': 'แอปธนาคารและกระเป๋าเงินไทย',
  'tmu_your_email': 'อีเมลของคุณ',
  'tmu_email_hint': 'สำหรับใบเสร็จของคุณ — ไม่ต้องสมัครสมาชิก',
  'tmu_email_invalid': 'กรอกอีเมลที่ถูกต้องสำหรับใบเสร็จของคุณ',
  'tmu_starting_payment': 'กำลังเริ่มการชำระเงิน…',
  'tmu_send_amount': 'ส่ง {amount}',
  'tmu_trust': 'ปลอดภัยด้วย Omise · mobiletopup.com ไม่จัดเก็บข้อมูลบัตรของคุณ',
  'tmu_view_payments': 'ดูการชำระเงิน',
  'tmu_cancel_link': 'ยกเลิกลิงก์',
  'tmu_phone_placeholder': '08X XXX XXXX หรือ +63 917 123 4567',
  'tmu_phone_examples': 'เบอร์ไทย (08X XXX XXXX) หรือเบอร์ต่างประเทศพร้อมรหัสประเทศ เช่น +63 917 123 4567',
  'tmu_global_off': 'ยังไม่รองรับเบอร์ต่างประเทศ — กรุณาใช้เบอร์มือถือไทย',
  'tmu_requests_in_thb': 'คำขอเป็นเงินบาท (THB) · {range}',
  'tmu_requests_in_usd': 'คำขอเป็นเงินดอลลาร์สหรัฐ (USD) · {range}',
  'tmu_requested_amount_usd': 'จำนวนเงินที่ขอ ($ USD)',
  'tmu_min_amount_usd': 'ขั้นต่ำ ($)',
  'tmu_max_amount_usd': 'สูงสุด ($)',
  'tmu_cap_hint_usd': 'แต่ละคำขอตั้งได้ {range} ผู้ส่งเป็นผู้จ่ายค่าธรรมเนียมและค่าแปลงสกุลเงิน — คุณจะได้รับเต็มจำนวนเป็นดอลลาร์สหรัฐเสมอ',
  'tmu_verify_cta': 'ยืนยันเบอร์นี้ทาง SMS (ไม่บังคับ)',
  'tmu_verify_why': 'ป้าย "ยืนยันแล้ว" ช่วยให้ผู้ส่งมั่นใจว่าเบอร์นี้เป็นของคุณจริง',
  'tmu_verify_sending': 'กำลังส่ง…',
  'tmu_verify_code_sent': 'ส่งรหัสแล้ว กรอกรหัส 6 หลักจาก SMS',
  'tmu_verify_code_label': 'รหัส 6 หลัก',
  'tmu_verify_confirm': 'ยืนยัน',
  'tmu_verify_checking': 'กำลังตรวจสอบ…',
  'tmu_verify_resend': 'ส่งรหัสอีกครั้ง',
  'tmu_verify_send_failed': 'ส่งรหัสไม่สำเร็จ ตรวจสอบเบอร์แล้วลองอีกครั้ง',
  'tmu_verify_failed': 'รหัสไม่ถูกต้อง ตรวจสอบแล้วลองอีกครั้ง',
  'tmu_verify_too_many': 'ลองหลายครั้งเกินไป กรุณารอสักครู่แล้วลองใหม่',
  'tmu_verified': 'ยืนยันแล้ว',
  'tmu_not_verified': 'ยังไม่ยืนยัน',
  'tmu_verified_number': 'เบอร์ที่ยืนยันแล้ว',
  'tmu_top_up_number': 'เติมเงินเบอร์นี้',
  'tmu_recipient_in': 'ผู้รับ · {country}',
  'tmu_receives': '{firstName} จะได้รับ',
  'tmu_total_usd': 'รวม (USD)',
  'tmu_charged_thb': 'คุณจะถูกเรียกเก็บ {amount} (≈ {rate} บาทต่อ 1 ดอลลาร์)',
  'tmu_pay_amount': 'ชำระ {amount}'
}
